import moment from "moment/moment";

export default class DateUtils {

  /**
   * Indicates the difference in days between dateString and targetDate. If dateString is X days before targetDate,
   * the result will be -X, if dateString is X days after targetDate, the result will be X, and if both are on the
   * same day, the result will be 0
   *
   * @param dateString
   * @param dateStringFormat
   * @param targetDate
   * @returns {number} A number indicating the difference in days between dateString and targetDate
   */
  static diffDays = (dateString, dateStringFormat = 'YYYY-MM-DD', targetDate = new Date()) => {
    const target = moment(targetDate).startOf('day');
    const date = DateUtils.parseDateString(dateString, dateStringFormat);

    if (!date.isValid()) {
      throw new Error(`Failed to parse '${dateString}' using format '${dateStringFormat}'`);
    }
    return date.diff(target, 'day');
  };

  /**
   * Parse a string to a moment instance
   * @param dateString
   * @param format
   * @returns {*|moment.Moment}
   */
  static parseDateString = (dateString, format = 'YYYY-MM-DD') => moment(dateString, format, true)
}
